import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { ExecutableDefinitionNode } from 'graphql';
import type { ClientPluginOperation } from 'villus';

export const extractQueryName = (operation: ClientPluginOperation) =>
  ((operation.query as TypedDocumentNode).definitions as ExecutableDefinitionNode[]).find(
    d => d.kind === 'OperationDefinition'
  )?.name?.value;
